import ChatAction from '../models/ChatAction'
import Config from '../config/config'

export default async function getHistory() {
  const response = await fetch(Config.historyService)
  const data = await response.json()

  const commands = data.map(function(item, index) {
    let command = new ChatAction()
    command.nick = item.nickname
    command.text = item.text
    command.timestamp = new Date(item.timestamp)
    command.id = 'history' + index
    command.command = 'HISTORY'
    return command
  })

  return commands.reverse()
}



// WEBPACK FOOTER //
// ./src/apis/history.js